import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  //   baseURL: 'http://localhost:8000/',
  withCredentials: false, // This is the default
  timeout: 60000
});

export const services = {
  async getCurrentPeriods(lottoMaster: number) {
    const response = await apiClient.post('/announce', { lottoMaster });
    return response;
  },
  async getPeriodsShow(lottoMaster: number) {
    const response = await apiClient.post('/announces', { lottoMaster });
    return response;
  },
  async getPeriods(date: string, type: string, lottoMaster: string) {
    const period = await apiClient.get('/period?announce=' + date + '&type=' + type + '&lottoMaster=' + lottoMaster);
    return period;
  },
  async getStatisticToday(lottoMaster: number) {
    const statisticToday = await apiClient.post('/announce', { lottoMaster });
    return statisticToday;
  },
  async getStatistics(lottoMaster: number) {
    const statistics = await apiClient.post('/announces', { lottoMaster });
    return statistics;
  }
};